<template>
    <div class="train-order-list">
        <el-card class="page-card">
            <template #header>
                <div class="card-header">火车票订单列表</div>
            </template>

            <div class="card-body">
                <el-row type="flex" justify="space-between" align="middle" class="toolbar">
                    <el-col>
                        <el-button type="primary" icon="el-icon-refresh" @click="fetchData">刷新</el-button>
                    </el-col>
                    <el-col>
                        <el-input size="small" placeholder="按订单号搜索" v-model="filters.order_no" style="width:200px"
                            clearable @clear="fetchData" @keyup.enter.native="fetchData">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="fetchData"></i>
                        </el-input>
                        <el-input size="small" placeholder="按联系人姓名搜索" v-model="filters.contact_name"
                            style="width:200px; margin-left:8px" clearable @clear="fetchData"
                            @keyup.enter.native="fetchData">
                            <i slot="suffix" class="el-input__icon el-icon-search" @click="fetchData"></i>
                        </el-input>
                    </el-col>
                </el-row>

                <el-table :data="pageData" stripe border style="width: 100%; margin-top: 12px" row-key="id"
                    :loading="loading">
                    <el-table-column prop="id" label="ID" width="80" align="center" header-align="center" />
                    <el-table-column prop="order_no" label="订单号" width="200" align="center" header-align="center" />
                    <el-table-column prop="amount" label="订单金额" width="120" align="center" header-align="center" />
                    <el-table-column prop="contact_name" label="联系人名" width="120" align="center"
                        header-align="center" />
                    <el-table-column prop="contact_mobile" label="联系人手机号" width="150" align="center"
                        header-align="center" />
                    <el-table-column prop="order_status" label="订单状态" width="120" align="center" header-align="center">
                        <template v-slot="{ row }">
                            <el-tag size="small" :type="getStatusTagType(row.order_status)">{{
                                formatStatus(row.order_status) }}</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="from_station" label="起始站" width="100" align="center" header-align="center" />
                    <el-table-column prop="to_station" label="到达站" width="100" align="center" header-align="center" />
                    <el-table-column prop="from_date_time" label="起始日期" width="180" align="center"
                        header-align="center" />
                    <el-table-column prop="to_date_time" label="到达日期" width="180" align="center"
                        header-align="center" />
                    <el-table-column prop="create_time" label="下单时间" width="180" align="center" header-align="center" />
                    <el-table-column prop="pay_time" label="支付时间" width="180" align="center" header-align="center" />
                    <!-- <el-table-column label="操作" fixed="right" width="150" align="center" header-align="center">
                        <template slot-scope="scope">
                            <el-button size="mini" @click="handleDetails(scope.row)">详情</el-button>
                        </template>
                    </el-table-column> -->
                </el-table>

                <div class="pagination-wrap">
                    <el-pagination layout="total, sizes, prev, pager, next, jumper" :total="total"
                        :page-sizes="[10, 15, 20, 50]" :page-size.sync="pager.pageSize" :current-page.sync="pager.page"
                        @size-change="handleSizeChange" @current-change="handleCurrentChange" />
                </div>
            </div>
        </el-card>

        <!-- 订单详情对话框 -->
        <el-dialog :visible.sync="detailDialog" title="订单详情" width="600px" :close-on-click-modal="false">
            <div v-if="detailData">
                <el-descriptions :column="1" border>
                    <el-descriptions-item label="ID">{{ detailData.id }}</el-descriptions-item>
                    <el-descriptions-item label="订单号">{{ detailData.order_no }}</el-descriptions-item>
                    <el-descriptions-item label="订单金额">{{ detailData.amount }}</el-descriptions-item>
                    <el-descriptions-item label="联系人名">{{ detailData.contact_name }}</el-descriptions-item>
                    <el-descriptions-item label="联系人手机号">{{ detailData.contact_mobile }}</el-descriptions-item>
                    <el-descriptions-item label="订单状态">{{ formatStatus(detailData.order_status)
                    }}</el-descriptions-item>
                    <el-descriptions-item label="起始站">{{ detailData.from_station }}</el-descriptions-item>
                    <el-descriptions-item label="到达站">{{ detailData.to_station }}</el-descriptions-item>
                    <el-descriptions-item label="起始日期">{{ detailData.from_date_time }}</el-descriptions-item>
                    <el-descriptions-item label="到达日期">{{ detailData.to_date_time }}</el-descriptions-item>
                    <el-descriptions-item label="下单时间">{{ detailData.create_time }}</el-descriptions-item>
                    <el-descriptions-item label="支付时间">{{ detailData.pay_time || '-' }}</el-descriptions-item>
                </el-descriptions>
            </div>
            <span slot="footer" class="dialog-footer">
                <el-button @click="detailDialog = false">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { trainOrderList } from '@/api/api'

export default {
    name: 'TrainOrderList',
    data() {
        return {
            loading: false,
            list: [],
            total: 0,
            pager: { page: 1, pageSize: 15 },
            filters: { order_no: '', contact_name: '' },
            detailDialog: false,
            detailData: null
        }
    },
    computed: {
        pageData() {
            // 服务端分页，直接返回list（服务端已按page和pageSize返回对应页数据）
            return this.list
        }
    },
    mounted() {
        this.fetchData()
    },
    methods: {
        async fetchData() {
            this.loading = true
            try {
                const params = {
                    page: this.pager.page,
                    per_page: this.pager.pageSize,
                    order_no: this.filters.order_no || undefined,
                    contact_name: this.filters.contact_name || undefined
                }
                const res = await trainOrderList(params)

                this.list = res.data.data || []
                this.total = res.data.total || 0
            } catch (err) {
                console.error('trainOrderList error', err)
                this.$message.error(err.message || '获取火车票订单列表失败')
                // 提供模拟数据以便展示
                this.list = this.getMockData()
                this.total = this.list.length
            } finally {
                this.loading = false
            }
        },

        // 获取模拟数据
        getMockData() {
            return [
                {
                    id: 1,
                    order_no: 'TR20241110001',
                    contact_name: '张三',
                    contact_mobile: '13800138001',
                    from_station: '北京南站',
                    to_station: '上海虹桥站',
                    from_date_time: '2024-11-15 08:00',
                    to_date_time: '2024-11-15 13:10',
                    amount: 553,
                    order_status: 2,
                    create_time: '2024-11-10 10:00:00',
                    pay_time: '2024-11-10 10:05:00'
                },
                {
                    id: 2,
                    order_no: 'TR20241110002',
                    contact_name: '李四',
                    contact_mobile: '13900139002',
                    from_station: '上海虹桥站',
                    to_station: '南京南站',
                    from_date_time: '2024-11-16 14:20',
                    to_date_time: '2024-11-16 16:30',
                    amount: 314,
                    order_status: 3,
                    create_time: '2024-11-10 14:30:00',
                    pay_time: '2024-11-10 14:35:00'
                },
                {
                    id: 3,
                    order_no: 'TR20241110003',
                    contact_name: '王五',
                    contact_mobile: '13700137003',
                    from_station: '广州南站',
                    to_station: '深圳北站',
                    from_date_time: '2024-11-17 09:00',
                    to_date_time: '2024-11-17 09:40',
                    amount: 74.5,
                    order_status: 7,
                    create_time: '2024-11-10 16:20:00',
                    pay_time: '2024-11-10 16:22:00'
                }
            ]
        },

        formatStatus(order_status) {
            const statusMap = {
                1: '占位中',
                2: '占位成功',
                3: '占位失败',
                5: '已取消',
                7: '出票中',
                8: '出票成功',
                9: '出票失败'
            }
            return statusMap[order_status] || '未知'
        },

        getStatusTagType(order_status) {
            const typeMap = {
                1: 'warning',
                2: 'primary',
                3: 'danger',
                5: 'danger',
                7: 'info',
                8: 'success',
                9: 'danger'
            }
            return typeMap[order_status] || 'default'
        },

        handleDetails(row) {
            this.detailData = row
            this.detailDialog = true
        },

        handleSizeChange(size) {
            this.pager.pageSize = size
            this.pager.page = 1
            this.fetchData()
        },

        handleCurrentChange(page) {
            this.pager.page = page
            this.fetchData()
        }
    }
}
</script>

<style scoped>
.page-card {
    margin: 20px 12px;
    height: calc(100vh - 64px - 48px);
    overflow-y: auto;
}

.card-header {
    font-weight: 700;
    color: #409EFF;
}

.card-body {
    padding: 12px;
}

.toolbar {
    margin-bottom: 6px;
}

.pagination-wrap {
    display: flex;
    justify-content: flex-end;
    margin-top: 12px;
}
</style>